








import { Component,  Vue, Prop } from 'vue-property-decorator';
import { area, stations } from '@/api/api';
import { Notify } from 'vant';

@Component({
    name: 'error'
})

export default class Suggestion extends Vue {
    
}
